import React from 'react'
import CustomerProfile from '../Components/CustomerProfile/CustomerProfile'
import Footer from '../Components/Footer/Footer'
import Header from '../Components/Header/Header'

const ProfilePage = () => {
  return (
    <>
    <Header/>
    <CustomerProfile/>

    {/* <Footer/> */}
    
    </>
  )
}

export default ProfilePage